import Joi from 'joi'

import { EntityConstants } from 'constants/EntityConstants'

const EMAIL_SEPARATOR = ';'

const singleEmailSchema = Joi.string().email({ tlds: false })

const splitEmails = (value: string): string[] =>
  value
    .split(EMAIL_SEPARATOR)
    .map((email) => email.trim())
    .filter(Boolean)

const distinctEmails = (emails: string[]): string[] => {
  const seen = new Set<string>()

  return emails.filter((email) => {
    const key = email.toLowerCase()

    if (seen.has(key)) {
      return false
    }

    seen.add(key)

    return true
  })
}

const getInvalidEmails = (emails: string[]): string[] =>
  emails.filter((email) => singleEmailSchema.validate(email).error)

const createMultipleEmailsSchema = (maxLength: number) =>
  Joi.string()
    .optional()
    .custom((value: string, helpers) => {
      const emails = distinctEmails(splitEmails(value))
      const invalidEmails = getInvalidEmails(emails)

      if (invalidEmails.length) {
        return helpers.error('any.custom', { invalidEmails: invalidEmails.join(', ') })
      }

      return emails.join(EMAIL_SEPARATOR)
    })
    .max(maxLength)
    .messages({
      'any.custom': 'Invalid email address: {{#invalidEmails}}',
      'string.max': `Email must be ${maxLength} characters or fewer`,
    })

export const multipleEmailsSchema = createMultipleEmailsSchema(
  EntityConstants.MAX_EMAIL_LENGTH,
).empty('')
